import { injectable } from 'inversify';
import { CognitoUser } from '@aws-amplify/auth';
import { useAppSelector } from '../../state/hooks';
import { AuthService } from '../../state/helperServices/auth/auth.service';
import { LoggedInUser } from '../../state/helperServices/auth/auth.interfaces';
import { UserCredentials } from '../../state/reduxRepositories/users/users.interfaces';

@injectable()
export class LoginDomainService {
  broadcastChannel: any;
  public constructor(private authService: AuthService) {
    this.broadcastChannel = new BroadcastChannel('login-domain');
    this.listenForLogout();
  }

  useLoggedInUserSelector = (): LoggedInUser => {
    return useAppSelector(this.authService.loggedInUserSelector);
  };

  useAuthErrorsSelector = () => {
    return useAppSelector(this.authService.authErrorsSelector);
  };

  userAuthLastErrorSelector = () => {
    return useAppSelector(this.authService.authLastErrorSelector);
  };

  // TODO: MOVE INTO SEPARATE SERVICE
  useNetworkSelector = () => {
    return useAppSelector(this.authService.checkIfIsNetworkConnected);
  };
  useIsSyncCompletedSelector = (): boolean => {
    return useAppSelector(this.authService.isSyncCompletedSelector);
  };
  useIsSyncingSelector = (): boolean => {
    return useAppSelector(this.authService.isSyncingSelector);
  };

  useDataStoreErrorSelector = () => {
    return useAppSelector(this.authService.dataStoreErrorSelector);
  };

  clearDataStoreError = () => {
    this.authService.clearDataStoreError();
  };

  useCognitoSelector = (): CognitoUser | undefined => {
    return useAppSelector(this.authService.cognitoUserSelector);
  };

  dispatchLogin(user: UserCredentials): void {
    this.authService.dispatchLogin(user);
  }

  useLoadingSelector = (): boolean => {
    return useAppSelector(this.authService.isLoadingSelector);
  };

  dispatchLogout(broadcast = true): void {
    this.authService.dispatchLogout();
    // Tell other tabs to logout
    if (broadcast) this.broadcastChannel.postMessage('logout');
  }

  listenForLogout() {
    this.broadcastChannel.addEventListener('message', (event: any) => {
      if (event.data === 'logout') {
        this.dispatchLogout(false); // don't rebroadcast or infinite loop
      }
    });
  }

  // useIsSyncCompletedSelector = (): boolean => {
  //   return useAppSelector(this.authDataService.isSyncCompletedSelector);
  // };
}
